import { prodEnvironment } from "@/env/env";
import * as ExcelJS from "exceljs";
import { comptageC3A, encoursc3atitre } from "./path.services";



export const editGcbloService = async (oldcmd: string, newFci: string, precision: string, etat:string) => {


  const response = await fetch(`${prodEnvironment.baseUrl}api/gcblo/rename`, {
    method: "PATCH",
    credentials: "include",
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ 
      fci:newFci,
      old:oldcmd,
      cmd:precision,
      etat:etat
    }) 
  })
  return response;
}

export const reorderGcbloCableService = async (
  commande: string,
  cableId: string,
  fromIndex: number,
  toIndex: number,
  targetCableId: string | null,
  placeAfter: boolean
) => {
  const response = await fetch(`${prodEnvironment.baseUrl}api/gcblo/edit/order`, {
    method: "PATCH",
    credentials: "include",
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      commande,
      cableId,
      fromIndex,
      toIndex,
      targetCableId,
      placeAfter,
    }),
  });

  return response;
};

export const getCablesByCommandeIds = async (ids: string[], commandes?: Array<{ precision?: string; fci?: string }>) => {
  const res = await fetch(`${prodEnvironment.baseUrl}api/gcblo/commandes/cables`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ids, commandes }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

// Nouvelle route basée uniquement sur les ObjectId de commande
export const getCablesByCommandeMongoIds = async (ids: string[]) => {
  const res = await fetch(`${prodEnvironment.baseUrl}api/gcblo/get/commandes/ids`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ids }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

// Liste "légère" des câbles en base (projection allégée côté backend)
export const listBaseCables = async () => {
  const res = await fetch(`${prodEnvironment.baseUrl}api/gcblo/get/commandes`, {
    method: "GET",
    credentials: "include",
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

// Liste des commandes (via suivi) avec quelques champs, avec recherche backend optionnelle
export const listBaseCommandes = async (search?: string) => {
  const params = new URLSearchParams({
    fields: "precision,fci,etat,soustraitant,cables_count,siren,insee,updatedAt,user_creation,gestionnaire,modepose,type_commande,retard",
    page: "1",
    limit: "5000",
  });
  if (search && search.trim().length >= 2) {
    params.set("search", search.trim());
  }
  const res = await fetch(`${prodEnvironment.baseUrl}api/gcblo/suivi/commandes?${params.toString()}`, {
    method: "GET",
    credentials: "include",
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`HTTP ${res.status} ${txt}`);
  }
  const json = await res.json();
  // l'endpoint renvoie { data, total, ... }
  return Array.isArray(json?.data) ? json.data : Array.isArray(json) ? json : [];
};

export const mergeCommandesApi = async (payload: { keepId: string; mergeIds: string[]; fields: Record<string, any> }) => {
  const res = await fetch(`${prodEnvironment.baseUrl}api/gcblo/fusion/commandes`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`HTTP ${res.status} ${txt}`);
  }
  return res.json();
};

export const listDuplicateCommandesApi = async () => {
  const res = await fetch(`${prodEnvironment.baseUrl}api/gcblo/fusion/commandes/duplicates`, {
    method: "GET",
    credentials: "include",
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`HTTP ${res.status} ${txt}`);
  }
  return res.json();
};

export const linkCommandeToCables = async (commandeId: string, cableIds: string[]) => {
  const res = await fetch(`${prodEnvironment.baseUrl}api/gcblo/link/commande`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ commandeId, cableIds }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const c6versC3a = async (cables: any, appuis: any, fci: any, insee: any) => {
  const url = `${prodEnvironment.baseUrl}api/gcblo/c6versC3a/`;

  try {
    const response = await fetch(url, {
      method: "POST",
      credentials: "include",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ cables: cables, appuis: appuis, insee: insee, fci: fci })
    });

    if (response.status === 200) {
      encoursc3atitre.value = "Téléchargement en cours...";
      const blobAr = await response.arrayBuffer(); 
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(blobAr);
      encoursc3atitre.value = "Workbook chargé.";
      const worksheetC3A = workbook.getWorksheet("Commandes Fermes");
      for (let rowNum = 15; rowNum <= worksheetC3A.rowCount; rowNum++) {
        if (!worksheetC3A.getCell(rowNum, 7).value) {
          break;
        }
        comptageC3A.value = comptageC3A.value + 1;
      }
      return new Blob([blobAr], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
    } else {
      encoursc3atitre.value = "Une erreur s'est produite.";
      throw new Error("La requête n'a pas réussi.");
    }
  } catch (error) {
    console.error('Une erreur s\'est produite :', error);
    throw error; // Propager l'erreur pour que le code appelant puisse la gérer
  }
};


/*export const c6versC3a = async (cables: any, appuis: any, fci:any, insee:any) => {
  const url = `${prodEnvironment.baseUrl}api/gcblo/c6versC3a/`;

  await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ cables: cables, appuis: appuis, insee: insee, fci:fci })
  }).then(async response => {
    if (await response.status === 200) {
      comptageC3A.value = cables.length;
      
    }
    else encoursc3atitre.value = "Une erreur s'est produite."
    return response.blob(); // Convertit la réponse en objet Blob
  })
    .then(blobData => {
      return blobData;
      
      /*const blobUrl = window.URL.createObjectURL(blobData);
      const downloadLink = document.createElement('a');
      downloadLink.href = blobUrl;
      downloadLink.download = 'F00000jjmmaa_C3A.xlsx';
      downloadLink.click();
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Une erreur s\'est produite :', error);
    });
}*/

export const mongoIDtoDate = (id: any) => {
  if (!id || typeof id !== "string") return "Pas de date";
  const safeId = id.trim();
  // Un ObjectId valide fait 24 caractAres hexadAcimaux
  if (safeId.length < 8) return "Pas de date";
  const timestamp = safeId.substring(0, 8);
  const classic = new Date(parseInt(timestamp, 16) * 1000);
  if (isNaN(classic.getTime())) return "Pas de date";
  const day = ("0" + classic.getDate()).slice(-2);
  const month = ("0" + (classic.getMonth() + 1)).slice(-2);
  const year = classic.getFullYear();
  const hours = ("0" + classic.getHours()).slice(-2);
  const minutes = ("0" + classic.getMinutes()).slice(-2);
  const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;
  return formattedDate;
};
